export default {
  data() {
    return {
      searchHightText: '更多搜索',
      searchHightIcon: 'el-icon-arrow-down',
      searchMoreShow: true
    }
  },
  methods: {
    // 筛选条件最多显示1行
    highSearch(e) {
      const dom = document.getElementsByClassName('search-form')
      if (this.searchHightText === '更多搜索') {
        dom[0].classList.remove('height-default');
        dom[0].classList.add('height-auto');
        this.searchHightText = '收起'
        this.searchHightIcon = 'el-icon-arrow-up'
      } else {
        dom[0].classList.remove('height-auto');
        dom[0].classList.add('height-default');
        this.searchHightText = '更多搜索'
        this.searchHightIcon = 'el-icon-arrow-down'
      }
    },
    searControl() {
      let self = this
      this.$nextTick(() => {
        const dom = document.getElementsByClassName('search-form')
        if (!dom.length) return false
        if (dom[0].scrollHeight > 60) {
          self.searchMoreShow = true
        } else {
          self.searchMoreShow = false
        }
        self.windowOnresize()
      })
    },
    windowOnresize() {
      let self = this
      window.onresize = () => {
        return (() => {
          const dom = document.getElementsByClassName('search-form')
          if (!dom.length) return false
          if (dom[0].scrollHeight > 60) {
            self.searchMoreShow = true
          } else {
            self.searchMoreShow = false
          }
          dom[0].style.height = '46px'
          this.searchHightText = '更多搜索'
          this.searchHightIcon = 'el-icon-arrow-down'
        })();
      }
    }
  }
}
